'use strict';

function valueIsNotInfinite(m) {
  return m !== -Infinity && m !== Infinity;
}

module.exports = valueIsNotInfinite;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/range/internal/valueIsNotInfinite.js
// module id = 1675
// module chunks = 0